<template>
  <f7-page name='calc'>
      <bc-navbar></bc-navbar>
      <div id="pages_maincontent">
          <h2 class="page_title">PAYMENT CALCULATOR</h2> 
            <div class="page_single layout_fullwidth_padding">
                <div class="contactform">
                    <div class="form_row">
                        <label>Vehicle Price ($)</label>
                        <input type="number" name="price" value="" class="form_input custom-text-size" placeholder="0" v-model="payment.vehiclePrice">
                    </div>
                    <div class="form_row">
                        <label>Down Payment ($)</label>
                        <input type="number" name="payment" value="" class="form_input custom-text-size" placeholder="0" v-model="payment.downPrice">
                    </div>

                        <div class="form_row">
                            <label>Term (Month)</label>
                            <select name="term" class="form_select custom-text-size"  v-model="payment.months">
                                <option value="12">12</option>
                                <option value="24">24</option>
                                <option value="36">36</option>
                                <option value="48">48</option>
                                <option value="60">60</option>
                                <option value="72">72</option>
                                <option value="84">84</option>
                            </select>
                        </div>
                        <div class="form_row">
                            <label>Interest Rate</label>
                            <input type="number" name="rate" value="" class="form_input custom-text-size" placeholder="0.0%" v-model="payment.interestRate">
                        </div>
   
                        <div class="form_row">
                            <label>Monthly Payment:</label>
                            <p><span>$</span>{{payment.mounthlyPayment}}</p>
                        </div>

                        <div class="form_row">
                            <label>Total Interest to Pay:</label>
                            <p><span>$</span>{{payment.totalInterest}}</p>
                        </div>


                    <div class="form_row">
                        <label>Total Amount:</label>
                        <p><span>$</span>{{payment.totalAmount}}</p>
                    </div>

                    <div class="form_row error" v-show="isError">
                       <label>Down Payment must be less then Vehicle Price</label>
                    </div>

                    <input type="button" class="form_submit" value="CALCULATE" @click="calculate" :style="borderStyle">
                </div>
            </div>
      </div>
  </f7-page>
</template>
<script>
import {Request} from '../shared/base.requests'
import config from '../../config/customer.api'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      payment: {
        vehiclePrice: null,
        downPrice: null,
        months: 60,
        interestRate: null,
        mounthlyPayment: 0,
        totalInterest: 0,
        totalAmount: 0
      },
      isError: false
    }
  },
  computed: {
    ...mapState({
      customization: state => state.common.customization
    }),
    borderStyle: function () {
      var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor : 'none'
      var backgroundStyle = this.customization.mainColor
      var colorStyle = this.customization.fontColor
      return {
        border: borderStyle,
        background: backgroundStyle,
        color: colorStyle
      }
    }
  },
  methods: {
    calculate () {
      if (Number(this.payment.vehiclePrice) === Number(this.payment.downPrice)) {
        return
      }
      if (Number(this.payment.interestRate) > 100) {
        this.payment.interestRate = 100
      }
      if (Number(this.payment.interestRate) < 0) {
        this.payment.interestRate = 0
      }
      if (Number(this.payment.vehiclePrice) < 0) {
        this.payment.vehiclePrice = 0
      }
      if (Number(this.payment.downPrice) < 0) {
        this.payment.downPrice = 0
      }

      if (Number(this.payment.vehiclePrice) > Number(this.payment.downPrice)) {
        this.isError = false

        const interest = this.payment.interestRate / 100 / 12
        var x = Math.pow(1 + interest, this.payment.months)
        this.payment.mounthlyPayment = ((this.payment.vehiclePrice - this.payment.downPrice) * x * interest) / (x - 1)
        this.payment.totalInterest = this.payment.mounthlyPayment * this.payment.months - (this.payment.vehiclePrice - this.payment.downPrice)
        this.payment.totalAmount = this.payment.mounthlyPayment * this.payment.months

        this.payment.totalInterest = this.payment.totalInterest.toFixed(2)
        this.payment.mounthlyPayment = this.payment.mounthlyPayment.toFixed(2)
        this.payment.totalAmount = this.payment.totalAmount.toFixed(2)
        Request.post(config.paymentActivityLog, { price: +this.payment.vehiclePrice, DownPayment: +this.payment.downPrice, interestRate: +this.payment.interestRate, months: +this.payment.months, monthlyPayment: +this.payment.mounthlyPayment })
      } else {
        this.isError = true
      }
    }
  }
}
</script>
<style scoped>
  #pages_maincontent{
      padding-top: 20px;
  }
  .error{
      color: red;
      border: 1px solid red;
      background-color: #fbe9e9;
      text-align: center;
  }

  .custom-text-size{
    font-size: 12pt;
  }
</style>



// WEBPACK FOOTER //
// calc.vue?015bffd1